{
    "Quantity": "Menge",
    "Item": "Artikel",
    "CMEnvironment": "CMEs",
    "TelephonyServer": "Telefonie-Server",
    "Partitions": "Partitionen",
    "Devices": "Geräte",
    "Agents": "Agenten",
    "ReportingUsers": "Melden von Benutzern",
    "NonReportingUsers": "Nicht meldende Benutzer",
    "Estate_ButtonHelpLabel": "Hilfe?",
    "Estate_ButtonSubmitLabel": "OK",
    "Estate_ButtonCancelLabel": "Absagen",
    "Estate_PromptMessage": "Möchten Sie dieses Fenster wirklich schließen? Alle geänderten Konfigurationen gehen beim Schließen verloren.",
    "Estate_PromptConfirm": "Ja",
    "Estate_PromptCancel": "Absagen",
    "NAME": "Estate"
}